/**
 * DHI Hospitality Footer Component
 * Section 9 from dhi_spec_v3.docx
 * Dark footer with logo and links
 */

const Footer = () => {
  return (
    <footer 
      data-testid="footer"
      style={{
        background: '#0A0A1A',
        color: 'rgba(255,255,255,0.45)',
        padding: '56px 48px 32px'
      }}
    >
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        gap: '80px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {/* Left Column - Logo + Tagline */}
        <div>
          {/* Footer Logo - 32px height, white */}
          <div style={{ color: '#FFFFFF', display: 'inline-block', marginBottom: '20px' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="200 160 3114 2502"
              style={{ height: '32px', width: 'auto', display: 'block' }}
              fill="currentColor"
              data-testid="footer-logo"
            >
              <g transform="scale(19.999999999999996) translate(10, 10)">
                <g transform="matrix(3.4634032612269547,0,0,3.4634032612269547,-0.08312038877371226,-36.712062678354265)" fill="currentColor">
                  <path d="M5.72 40 l-0.44 0 t-0.52 -0.08 q-1.4 0.04 -2.3 -0.6 t-1.42 -1.68 t-0.74 -2.36 t-0.26 -2.7 t0.02 -2.68 t0.06 -2.3 q0.04 -2.04 1.2 -3.44 t2.76 -1.94 t3.32 -0.08 t2.92 2.14 l0 -12.64 q0 -0.44 0.3 -0.74 t0.74 -0.3 l3.2 0 q0.44 0 0.74 0.3 t0.3 0.74 l0 27.28 l0 0.04 q0 0.44 -0.3 0.74 t-0.74 0.3 l-3.2 0 q-0.44 0 -0.74 -0.3 t-0.3 -0.74 l0 -0.04 l0 -1.28 q-0.8 1.08 -1.98 1.72 t-2.62 0.64 z M10.32 29.88 q0 -2.52 -0.76 -3.76 t-1.68 -1.34 t-1.68 0.86 t-0.76 2.84 l0 4.96 q0 1.8 0.36 2.74 t0.9 1.24 t1.18 0.02 t1.18 -0.98 t0.9 -1.68 t0.36 -2.1 l0 -2.8 z M19.067 11.64 q0 -0.44 0.3 -0.74 t0.74 -0.3 l3.2 0 q0.44 0 0.76 0.3 t0.32 0.74 l0 12.64 q0.76 -1.04 1.96 -1.7 t2.6 -0.66 q0.8 0 1.78 0.22 t1.82 0.86 t1.42 1.74 t0.58 2.86 l0 11.36 q0 0.44 -0.3 0.74 t-0.74 0.3 l-3.2 0 q-0.44 0 -0.74 -0.3 t-0.3 -0.74 l0 -10.48 q0 -1.76 -0.36 -2.72 t-0.9 -1.24 t-1.18 0 t-1.18 0.96 t-0.9 1.66 t-0.36 2.1 l0 9.72 q0 0.44 -0.32 0.74 t-0.76 0.3 l-3.2 0 q-0.44 0 -0.74 -0.3 t-0.3 -0.74 l0 -27.32 l0 0 z M39.054 21.92 l3.2 0 q0.44 0 0.76 0.32 t0.32 0.76 l0 15.96 q0 0.44 -0.32 0.74 t-0.76 0.3 l-3.2 0 q-0.44 0 -0.74 -0.3 t-0.3 -0.74 l0 -15.96 q0 -0.44 0.3 -0.76 t0.74 -0.32 z M42.254 11.76 q0.44 0 0.76 0.32 t0.32 0.76 l0 4.52 q0 0.44 -0.32 0.74 t-0.76 0.3 l-3.2 0 q-0.44 0 -0.74 -0.3 t-0.3 -0.74 l0 -4.52 q0 -0.44 0.3 -0.76 t0.74 -0.32 l3.2 0 z"/>
                </g>
                <g transform="matrix(0.7036142398283567,0,0,0.7036142398283567,-0.5628914002504207,109.11518537440918)" fill="currentColor">
                  <path d="M0.8 20 l0 -15.6 l3.98 0 l0 6.06 l6.36 0 l0 -6.06 l4 0 l0 15.6 l-4 0 l0 -5.8 l-6.36 0 l0 5.8 l-3.98 0 z M31.0845 20.3 c-2.26 0 -4.2 -0.8 -5.82 -2.38 c-1.64 -1.58 -2.46 -3.5 -2.46 -5.72 s0.82 -4.14 2.46 -5.72 c1.62 -1.58 3.56 -2.38 5.82 -2.38 c2.28 0 4.24 0.8 5.86 2.38 s2.42 3.5 2.42 5.72 s-0.8 4.14 -2.42 5.72 s-3.58 2.38 -5.86 2.38 z M31.0845 16.44 c1.2 0 2.2 -0.42 3.02 -1.24 s1.22 -1.82 1.22 -3 s-0.4 -2.2 -1.22 -3.02 s-1.82 -1.22 -3.02 -1.22 c-1.18 0 -2.18 0.42 -3 1.24 s-1.24 1.82 -1.24 3 s0.42 2.18 1.24 3 s1.82 1.24 3 1.24 z M53.669 20.3 c-1.94 0 -3.52 -0.42 -4.76 -1.28 s-1.86 -2.02 -1.86 -3.52 l0 -0.18 l-0.02 -0.8 l3.92 0 l0 0.9 c0 0.34 0.24 0.66 0.7 0.96 s1.1 0.46 1.94 0.46 c0.7 0 1.2 -0.1 1.52 -0.28 c0.3 -0.18 0.46 -0.42 0.46 -0.68 c0 -0.32 -0.2 -0.6 -0.58 -0.84 c-0.4 -0.24 -1.1 -0.52 -2.08 -0.86 c-0.62 -0.22 -1.14 -0.4 -1.56 -0.56 s-0.92 -0.4 -1.5 -0.72 c-0.58 -0.3 -1.06 -0.64 -1.4 -0.98 s-0.64 -0.76 -0.9 -1.28 s-0.38 -1.08 -0.38 -1.7 c0 -1.46 0.56 -2.64 1.7 -3.52 s2.6 -1.32 4.4 -1.32 c1.86 0 3.38 0.46 4.58 1.38 s1.8 2.14 1.8 3.66 l0 0.98 l-3.9 0 l0 -0.9 c0 -0.42 -0.2 -0.82 -0.62 -1.16 s-1.02 -0.5 -1.78 -0.5 c-0.62 0 -1.1 0.1 -1.42 0.3 c-0.32 0.22 -0.48 0.46 -0.48 0.76 s0.18 0.54 0.54 0.74 c0.36 0.22 1.04 0.5 2.04 0.84 l1.02 0.36 l1.08 0.44 c0.46 0.22 0.84 0.4 1.12 0.58 s0.6 0.42 0.98 0.72 s0.66 0.62 0.88 0.92 c0.2 0.3 0.38 0.68 0.54 1.1 c0.14 0.42 0.22 0.88 0.22 1.34 c0 1.48 -0.58 2.62 -1.72 3.42 c-1.14 0.82 -2.64 1.22 -4.48 1.22 z M67.5335 20 l0 -15.6 l6.88 0 c1.96 0 3.48 0.5 4.54 1.5 c1.06 1.02 1.58 2.28 1.58 3.74 c0 1.54 -0.52 2.82 -1.58 3.82 s-2.56 1.52 -4.54 1.52 l-2.88 0 l0 5.02 l-4 0 z M71.5335 11.78 l2.66 0 c1.54 0 2.3 -0.7 2.3 -2.12 c0 -0.6 -0.18 -1.08 -0.56 -1.48 s-0.96 -0.58 -1.74 -0.58 l-2.66 0 l0 4.18 z M88.198 20 l0 -15.6 l4 0 l0 15.6 l-4 0 z M104.7225 20 l0 -11.72 l-4.86 0 l0 -3.88 l13.72 0 l0 3.88 l-4.86 0 l0 11.72 l-4 0 z M121.247 20 l6.32 -15.6 l3.96 0 l6.3 15.6 l-4.36 0 l-1.26 -3.48 l-5.3 0 l-1.3 3.48 l-4.36 0 z M128.147 13.28 l2.78 -0.02 l-1.38 -3.74 z M145.4915 20 l0 -15.6 l3.98 0 l0 11.74 l7.48 0 l0 3.86 l-11.46 0 z M164.616 20 l0 -15.6 l4 0 l0 15.6 l-4 0 z M181.1405 20 l0 -11.72 l-4.86 0 l0 -3.88 l13.72 0 l0 3.88 l-4.86 0 l0 11.72 l-4 0 z M203.825 20 l0 -5.72 l-6.16 -9.88 l4.7 0 l3.44 5.66 l3.46 -5.66 l4.72 0 l-6.18 9.88 l0 5.72 l-3.98 0 z"/>
                </g>
              </g>
            </svg>
          </div>
          
          {/* Tagline */}
          <p style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '13px',
            lineHeight: 1.7,
            color: 'rgba(255,255,255,0.45)'
          }}>
            AI-powered hotel digital audits<br/>
            for premium hospitality brands.
          </p>
        </div>
        
        {/* Right Columns - Links */}
        <div style={{ display: 'flex', gap: '64px' }}>
          {/* Solutions Column */}
          <div>
            <div style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '10px',
              fontWeight: 700,
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              color: 'rgba(255,255,255,0.35)',
              marginBottom: '16px'
            }}>
              Solutions
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <a 
                href="https://dhihospitality.com/revenue-solutions" 
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '13px',
                  color: 'rgba(255,255,255,0.55)',
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.55)'}
              >
                Revenue Management
              </a>
              <a 
                href="https://dhihospitality.com/commercial-solutions"
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '13px',
                  color: 'rgba(255,255,255,0.55)',
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.55)'}
              >
                Commercial Solutions
              </a>
              <a 
                href="https://dhihospitality.com/management-solutions"
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '13px',
                  color: 'rgba(255,255,255,0.55)',
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.55)'}
              >
                Management Solutions
              </a>
            </div>
          </div>
          
          {/* Company Column */}
          <div>
            <div style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '10px',
              fontWeight: 700,
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              color: 'rgba(255,255,255,0.35)',
              marginBottom: '16px'
            }}>
              Company
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <a 
                href="https://dhihospitality.com/" 
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '13px',
                  color: 'rgba(255,255,255,0.55)',
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.55)'}
              >
                About
              </a>
              <a 
                href="https://dhihospitality.com/contact-us"
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '13px',
                  color: 'rgba(255,255,255,0.55)',
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.55)'}
              >
                Contact Us
              </a>
            </div>
          </div>
          
          {/* Legal Column */}
          <div>
            <div style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '10px',
              fontWeight: 700,
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              color: 'rgba(255,255,255,0.35)',
              marginBottom: '16px'
            }}>
              Legal
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <a 
                href="https://dhihospitality.com/privacy-policy"
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '13px',
                  color: 'rgba(255,255,255,0.55)',
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.55)'}
              >
                Privacy Policy
              </a>
              <a 
                href="https://dhihospitality.com/terms"
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '13px',
                  color: 'rgba(255,255,255,0.55)',
                  textDecoration: 'none',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.55)'}
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div style={{
        marginTop: '48px',
        paddingTop: '24px',
        borderTop: '1px solid rgba(255,255,255,0.08)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: '1200px',
        margin: '48px auto 0'
      }}>
        <span style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '12px',
          color: 'rgba(255,255,255,0.3)'
        }}>
          © {new Date().getFullYear()} dhi Hospitality. All rights reserved.
        </span>
        <span style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '12px',
          color: 'rgba(255,255,255,0.3)'
        }}>
          Powered by DataForSEO · Google APIs
        </span>
      </div>
    </footer>
  );
};

export default Footer;
